<template>
	<div class="countryAndBudgetVal">
		<el-row :gutter="40">
			<el-col :span="12">
				<div class="col">
					<div class="col-box">
						<span class="text">已排除：</span>
						<div class="valueDiv">{{ removeRegion }}</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="col">
					<div class="col-box">
						<span class="text">重点添加：</span>
						<div class="valueDiv">{{ importantRegion || '无' }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<div class="col">
					<div class="col-box">
						<span class="text">账户日预算：</span>
						<div class="valueDiv" v-if="!isEdit">
							<span>{{ budgetVal }}</span>
							<ig-icon
								class="icon budget_edit_icon"
								name="bianji1"
								v-if="isShowEdit"
								@click="() => (isEdit = true)"
							></ig-icon>
						</div>
						<div class="budget_edit" v-else>
							<el-input-number
								size="mini"
								placeholder="请输入内容"
								v-model="budgetValCopy"
								:controls="false"
								:min="1"
							></el-input-number>
							<el-button type="primary" size="mini" @click="budgetValChange">保存</el-button>
							<el-button size="mini" @click="() => (isEdit = false)">取消</el-button>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';

export default {
	props: ['importantRegionList', 'removeRegionList', 'budgetVal', 'regionId'],
	data() {
		return {
			isEdit: false,
			budgetValCopy: 0,
		};
	},
	watch: {
		budgetVal: {
			immediate: true,
			handler(newVal) {
				this.budgetValCopy = newVal;
			},
		},
	},
	computed: {
		removeRegion() {
			// 取消俄罗斯注释
			// let defaultList = [
			// 	{ regionId: '2736', regionName: '苏丹' },
			// 	{ regionId: '2643', regionName: '俄罗斯' },
			// ];
			let defaultList = [{ regionId: '2736', regionName: '苏丹' }];
			let arr = [];
			if (this.removeRegionList && this.removeRegionList.length) {
				// 取消俄罗斯注释
				// let v = this.removeRegionList.filter(
				// 	item => item.regionName !== '苏丹' && item.regionName !== '俄罗斯'
				// );
				let v = this.removeRegionList.filter(item => item.regionName !== '苏丹');
				arr = v.concat(defaultList).map(e => {
					return e.regionName;
				});
			}

			return arr.length ? arr.toString() : '';
		},
		importantRegion() {
			let arr = [];
			if (this.importantRegionList && this.importantRegionList.length) {
				arr = this.importantRegionList.map(e => {
					return e.regionName;
				});
			}
			return arr.length ? arr.toString() : '';
		},
		isShow() {
			return this.$route.query.isShow == '0' ? false : true;
		},
		isShowEdit() {
			return this.$route.query.automationStatus === 4 ? false : true;
		},
	},
	methods: {
		// 修改预算
		async budgetValChange() {
			try {
				let { automationId: id, budgetValCopy: budgetVal } = this;
				await adsNewOnlineSer.updateAdsAutoRegion({
					id,
					budgetVal,
					versionNum: 1,
				});
				this.$message.success('更新预算成功');
				this.$parent.requestData();
			} catch (error) {
				console.error('更新预算失败', error);
			} finally {
				this.isEdit = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.countryAndBudgetVal {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
	padding: 20px 40px;
	.col {
		height: auto;
		margin-bottom: 20px;
	}

	.col-box {
		display: flex;
		.text {
			width: 100px;
			text-align: right;
			line-height: 20px;
		}
		.valueDiv {
			flex: 1;
			line-height: 20px;
			word-spacing: 1px;
			letter-spacing: 1px;

			.budget_edit_icon {
				margin-left: 10px;
				cursor: pointer;
				font-size: 15px;
				color: #409eff;
			}
		}

		.budget_edit {
			display: flex;

			.el-input-number {
				margin-right: 10px;
			}
		}
	}
}
</style>
